import r from "./index232.mjs";
import t from "./index231.mjs";
function n(o) {
  return r("MuiSvgIcon", o);
}
t("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
export {
  n as getSvgIconUtilityClass
};
